/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="10.82"
        height="19.57"
        viewBox="0 0 10.82 19.57"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="m0 19.57 5.41-4.51 5.41 4.51V0H0ZM1 1h8.82v16.43l-4.41-3.67L1 17.43Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'BookmarkIcon';

export default Icon;
